export default __webpack_public_path__ + "static/bara-c46d8ef04a307ee6266f57ff1c7bddbb.jpg";